// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

import CoreComponent from './internal-do-not-use-core';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { validateProps } from '@amzn/awsui-component-toolkit/internal';



const Checkbox = React.forwardRef((props, ref) => {
    validateProps('Checkbox', props, ["style"], {}, 'console');
    return React.createElement(CoreComponent, {ref,...props});
});


applyDisplayName(Checkbox, 'Checkbox');
export default Checkbox;
